import React from 'react';
import styles from './exportButton.module.css';

interface ExportButtonProps {
  onClick: () => void;
}

const ExportButton: React.FC<ExportButtonProps> = ({ onClick }) => (
  <button type="button" className={styles.btn} onClick={onClick}>
    EXPORT
  </button>
);

export default ExportButton;
